import IpubDateTimePicker from './src/main'

/* istanbul ignore next */
IpubDateTimePicker.install = function(Vue) {
  Vue.component(IpubDateTimePicker.name, IpubDateTimePicker)
}

export default IpubDateTimePicker
